import React, { useEffect, useState } from 'react';
import '../styles/css/index.css';

import { fetchData } from '../utils/api'
import { apiUrl } from '../config'
import { useSearchParams } from 'react-router-dom';
import FooterComponent from '../components/FooterComponent';
import HeaderComponent from '../components/HeaderComponent';
import BookingFormComponent from '../components/BookingFormComponent';
import { useParams } from "react-router-dom";
import { useLanguage } from '../LanguageContext';
import Protected from '../components/system/Protected';
import { getNumberOfDays } from '../utils/dynamic';

function RoomDetail() {
  const { id, typePage } = useParams();
  const [searchParams] = useSearchParams();
  const checkIn = searchParams.get("checkIn");
  const checkOut = searchParams.get("checkOut");
  const periodStatus = searchParams.get("periodStatus", false);

  const [room, setRoom] = useState(null);
  const [mainMedia, setMainMedia] = useState(null);  // Изменил название на mainMedia
  const [mediaType, setMediaType] = useState('image'); // 'image' или 'video'
  const { language } = useLanguage();
  const [bookingCheckVisible, setBookingCheckVisible] = useState(false);
  const [mayPay, setMayPay] = useState(0);

  const getAccBookingCount = async () => {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await fetchData(`${apiUrl}/api/check-count-bookings`, "GET", token)
      setMayPay(response.request.data)
    } catch (error) {
      // console.error("Ошибка при перенаправлении на банк.")
    }
  }

  useEffect(() => {
    const fetchRooms = async () => {
      let get = ''
      if (typePage === 'book') {
        get = `?checkin=${checkIn}&checkout=${checkOut}`
      }
      const response = await fetchData(`${apiUrl}/api/${language}/get-room/${id}${get}`, "GET")
      if (response.request && response.request.status === 0) {
        const fetchedRoom = response.request.data.room;
        setRoom(response.request.data.room)
        // Устанавливаем первое изображение, если оно существует
        if (fetchedRoom.images && fetchedRoom.images.length > 0) {
          setMainMedia(fetchedRoom.images[0]);
          setMediaType('image');
        } else if (fetchedRoom.videos && fetchedRoom.videos.length > 0) {
          // Если нет фото, устанавливаем первое видео
          setMainMedia(fetchedRoom.videos[0]);
          setMediaType('video');
        }
      }
    }
    fetchRooms()
    if (typePage === "book") {
      const role = localStorage.getItem('asd');
      if (role) {
        getAccBookingCount()
      }
    }
  }, [language, id, typePage]);

  // Отображение формы для перехода на страницу банка
  const handleSubmitToBookingForm = () => {
    // Проверка авторизации при загрузке компонента
    setBookingCheckVisible(true); // Show the booking form
  }

  const closeBookingForm = () => {
    setBookingCheckVisible(false)
  };

  // Функция для установки основного медиа
  const setMainMediaItem = (media, type) => {
    setMainMedia(media);
    setMediaType(type);
  };

  const savedLanguage = localStorage.getItem('language') || 'tm';
  // Состояние для языка
  const langs = {
    'ru': {
      'additional_info': "Дополнительная информация:",
      'searchResultTitle': "Результаты поиска",
      'total_amount': "Общая сумма",
      'booking_price': "Услуга бронирования",
      'book_price': "Сумма для оплаты онлайн",
      'first_day': "Цена номера в сутки",
      'full_period': "Цена номера за весь период",
      'room_type': "Тип апартамента",
      'count_guests': "Кол. гостей",
      'description': "Описание",
      'amenities': "Оснащение",
      'max_rooms_title': "Количество комнат в номере",
      'rooms_title': "На данный момент доступно номеров",
      'no_rooms_available': "Свободных номеров нет.",
      'button_book': "Забронировать",
      'message': "У вас уже имеются бронирования",
    },
    'tm': {
      'additional_info': "Goşmaça maglumat:",
      'searchResultTitle': "Gözleg netijeleri",
      'total_amount': "Jemi",
      'booking_price': "Bron etmek hyzmaty",
      'book_price': "Onlaýn tölemek üçin mukdar",
      'first_day': "Bir gije gündiz üçin otagyň bahasy",
      'full_period': "Doly möhlet üçin baha",
      'room_type': "Otagyň görnüşi",
      'count_guests': "Myhmanlaryň sany",
      'description': "Beýany",
      'amenities': "Otag enjamlary",
      'max_rooms_title': "Otag sany",
      'rooms_title': "Häzirki wagtda elýeterli otaglar",
      'no_rooms_available': "Elýeterli otag ýok.",
      'button_book': "Bent etmek",
      'message': "Siziň eýýäm bronlamalaryňyz bar",
    },
    'en': {
      'additional_info': "Additional information:",
      'searchResultTitle': "Results",
      'total_amount': "Total amount",
      'booking_price': "Booking service",
      'book_price': "Amount to pay online",
      'first_day': "Price per night",
      'full_period': "Price for full period",
      'room_type': "Apartment Type",
      'count_guests': "Guests",
      'description': "Description",
      'amenities': "Amenities",
      'max_rooms_title': "Rooms in the Apartment",
      'rooms_title': "Currently Available Rooms",
      'no_rooms_available': "No available rooms.",
      'button_book': "Book now",
      'message': "You already have bookings",
    }
  };

  if (!room) {
    return <div>Загрузка...</div>; // Показать пока данные не загружены
  }

  let priceForExtraGuests = 0;
  let priceForExtraGuestsForOneDay = 0;
  if (room.id === 1) {
    if (checkIn !== null && checkOut !== null) {
      const daysForExtraGuest = getNumberOfDays(checkIn, checkOut);
      priceForExtraGuests = 120 * daysForExtraGuest;
    } else {
      priceForExtraGuests = 120;
      priceForExtraGuestsForOneDay = 120;
    }
  }

  return (
    <React.Fragment>
      <HeaderComponent />
      <div className="container container-rooms-result" id='results-block'>
        <h2 className="container-rooms-result__title">{langs[savedLanguage].title}</h2>
        <h4 className='text searching-status-booking' id='results-block-inner-status'>{!room && "Номеров не осталось"}</h4>
        {room ? (
          <div className="room-result" id='results-block-inner'>
            <h3 className="room-result__type">{room.translations.room_type}</h3>
            <div className='room-result__main-images-block'>
              <div className='room-result__main-images-block__main-image'>
                {mainMedia !== null && (
                  mediaType === 'image' ? (
                      <img
                        src={`${apiUrl}/api/images/${mainMedia}`}
                        alt={room.translations.room_type}
                      />
                    ) : (
                      <video
                        width="100%"
                        height="auto"
                        src={`${apiUrl}/api/videos/${mainMedia}`}
                        controls
                        autoPlay
                        muted
                        playsInline
                        className="room-result__main-video"
                      >
                        Ваш браузер не поддерживает видео тег.
                      </video>
                    )
                  )
                }
              </div>

              {/* Миниатюры изображений */}
              {room.images && room.images.length > 0 && (
                <div className="room-result__main-images-block__images">
                  {room.images.map((image, index) => (
                    <div
                      key={`img-${index}`}
                      className={`thumbnail ${mainMedia === image && mediaType === 'image' ? 'active' : ''}`}
                      onClick={() => setMainMediaItem(image, 'image')}
                    >
                      <img
                        src={`${apiUrl}/api/images/${image}`}
                        alt={room.translations.room_type + (index + 1)}
                      />
                    </div>
                  ))}
                </div>
              )}

              {/* Миниатюры видео */}
              {room.videos && room.videos.length > 0 && (
                <div className="room-result__main-images-block__videos">
                  {room.videos.map((video, index) => (
                    <div
                      key={`vid-${index}`}
                      className={`thumbnail ${mainMedia === video && mediaType === 'video' ? 'active' : ''}`}
                      onClick={() => setMainMediaItem(video, 'video')}
                    >
                      <video
                        width="100%"
                        height="100%"
                        src={`${apiUrl}/api/videos/${video}`}
                        muted
                        playsInline
                        preload="metadata"
                        className="room-result__thumb"
                      />
                      <div className="video-play-icon">▶</div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <ul className='room-result__services-room room-result__hr-bottom'>
              {typePage === 'book' && (
                <>
                  {room.rooms_price_status === 1 && (
                    <li className="room-result__services-room__item">
                      <span>{langs[savedLanguage].book_price}</span>
                      {parseInt(room.price) + priceForExtraGuests} TMT
                    </li>
                  )}
                  {room.booking_price_status === 1 && (
                    <li className="room-result__services-room__item">
                      <span>{langs[savedLanguage].book_price}</span>
                      {room.booking_price} TMT
                    </li>
                  )}
                </>
              )}
              {room.booking_price_status !== 0 &&
                <li className='room-result__services-room__item'><span>{langs[savedLanguage].booking_price}</span>{room.booking_price} TMT</li>
              }
              {typePage !== 'book' &&
                <li className='room-result__services-room__item'><span>{langs[savedLanguage].first_day}</span>{parseInt(room.price) + priceForExtraGuestsForOneDay} TMT</li>
              }
              {typePage === 'book' &&
                <>
                  <li className='room-result__services-room__item'><span>{langs[savedLanguage].full_period}</span>{parseInt(room.price_full_period) + priceForExtraGuests} TMT</li>
                </>
              }
              {(room.booking_price_status !== 0 && room.rooms_price_status !== 0) &&
                <li className='room-result__services-room__item'><span>{langs[savedLanguage].total_amount}</span>
                  {(room.rooms_price_status === 1 && room.booking_price_status === 1) &&
                    parseInt(room.price) + priceForExtraGuests + parseInt(room.booking_price)
                  }
                  {(room.rooms_price_status === 1) &&
                    parseInt(room.price) + priceForExtraGuests
                  }
                  {(room.booking_price_status === 1) &&
                    parseInt(room.booking_price)
                  }
                  TMT
                </li>
              }
              <li className='room-result__services-room__item'><span>{langs[savedLanguage].room_type}</span>{room.translations.room_type}</li>
              <li className='room-result__services-room__item'><span>{langs[savedLanguage].count_guests}</span>{room.id === 1 ? room.capacity + 1 : room.capacity}</li>
            </ul>
            <div className='room-result__description-room room-result__hr-bottom'>
              <div className='room-result__description-room__block'>
                <h4 className='room-result__description-room__title'>{langs[savedLanguage].description}</h4>
                <pre className='room-result__description-room__text'>
                  {room.translations.description}
                </pre>
              </div>
              {room.translations.additional_info &&
                <ul className='room-result__additional-services'>
                  <li className='room-result__additional-services__item red-text'>{langs[savedLanguage].additional_info}</li>
                  <pre className='red-text'>{room.translations.additional_info}</pre>
                </ul>
              }
              {room.amenities &&
                <ul className='room-result__additional-services'>
                  <li className='room-result__additional-services__item room-result__additional-services__title'>{langs[savedLanguage].amenities}</li>
                  {room.amenities.map((amenite, index) => (
                    <li key={index} className='room-result__additional-services__item'>{amenite}</li>
                  ))}
                </ul>
              }
            </div>


            <p className="room-result__floor">
              {langs[savedLanguage].max_rooms_title}: <strong>{room.rooms_count}</strong>
            </p>
            {typePage === 'book' && (
              mayPay < 2 && room ? (
                <button className="button-booking pulse-button button-zj" onClick={() => handleSubmitToBookingForm(room)}>
                  {langs[language].button_book}
                </button>
              ) : (
                <p className='red-text'>{langs[language].message}</p>
              )
            )}
          </div>
        ) : null}
      </div>
      {bookingCheckVisible && (
        <Protected
          element={
            <BookingFormComponent room={room} checkIn={checkIn} checkOut={checkOut} onClose={closeBookingForm} />
          } requiredRoles={['client']}
        />
      )}
      <FooterComponent />
    </React.Fragment>
  );
}

export default RoomDetail;